import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';

/**
 * Unauthorized page component
 */
@Component({
    selector: 'app-unauthorized-page',
    templateUrl: './unauthorized-page.component.html',
    styleUrls: ['./unauthorized-page.component.scss'],
    standalone: false
})
export class UnauthorizedPageComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit(): void {
  }

  goBack() {
    this.location.back()
  }
}
